/** Brand + warm analytics palette (navy primary, not default blue). */
export const DPAT_BRAND = "#16325a";

export const DPAT_CHART = {
  navy: "#16325a",
  navyLight: "rgba(22, 50, 90, 0.12)",
  teal: "#0d9488",
  tealLight: "rgba(13, 148, 136, 0.35)",
  amber: "#d97706",
  amberLight: "rgba(217, 119, 6, 0.35)",
  coral: "#e11d48",
  coralLight: "rgba(225, 29, 72, 0.3)",
  emerald: "#059669",
  emeraldLight: "rgba(5, 150, 105, 0.35)",
  violet: "#7c3aed",
  slate: "#64748b",
  sand: "#d6b8a3",
};

export const ASSESSMENT_STATUS_CHART_COLORS = {
  none: DPAT_CHART.slate,
  "Yet to start": DPAT_CHART.slate,
  Start: DPAT_CHART.navy,
  Pending: DPAT_CHART.amber,
  Reviewed: DPAT_CHART.violet,
  Completed: DPAT_CHART.emerald,
  Closed: DPAT_CHART.teal,
};

export const TIER_CHART_COLORS = {
  Excellent: DPAT_CHART.emerald,
  "Very Good": DPAT_CHART.teal,
  Good: DPAT_CHART.navy,
  Fair: DPAT_CHART.amber,
  Poor: DPAT_CHART.coral,
};

export const METRIC_ICON_STYLES = [
  { bg: "bg-[#16325a]/10", color: DPAT_BRAND },
  { bg: "bg-teal-500/10", color: DPAT_CHART.teal },
  { bg: "bg-amber-500/10", color: DPAT_CHART.amber },
  { bg: "bg-violet-500/10", color: DPAT_CHART.violet },
  { bg: "bg-rose-500/10", color: DPAT_CHART.coral },
];

export const tooltipStyle = {
  borderRadius: 10,
  border: "1px solid rgba(22, 50, 90, 0.15)",
  backgroundColor: "#fff",
  fontSize: 12,
  boxShadow: "0 4px 14px rgba(22, 50, 90, 0.08)",
};
